import React, { Fragment } from 'react';

function TechIntroPara() {
  return (
    <Fragment>
      We are developing the open-source xMacroscope platform. This software and technology platform
      will allow us to build science center exhibit experiences that let visitors construct data
      visualization using their own experiences in interactive science exhibits.
    </Fragment>
  );
}

export default TechIntroPara;
